import { Container, Row } from 'styled-bootstrap-grid'
import styled from 'styled-components/macro'
import { Card } from 'antd'

export const Layout = styled(Container)`
  max-width: none !important;
  width: auto;

  position: relative; /* for aligning page background image */
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: 1921px) {
    margin: 0 auto;
    width: 1760px;
  }

  @media only screen and (max-width: 1920px) {
    margin: 0 80px;
  }

  @media only screen and (max-width: 1360px) {
    margin: 0 40px;
  }

  @media only screen and (max-width: 767px) {
    margin: 0 16px;
  }
`

export const CenteredRow = styled(Row)`
  text-align: center;
  justify-content: center;

  &.buttons {
    margin-top: 40px;
    margin-bottom: 40px;

    button:first-of-type {
      margin-right: 24px;
    }
  }

  & .download-text {
    padding-top: 40px;
    padding-bottom: 40px;
  }
`

export const Label = styled.div`
  width: 100%;
  font-size: 12px;
  font-weight: 900;
  line-height: 1.33;
  color: ${({ theme: { colors } }) => colors.main};
`

export const Box = styled(Card)`
  &.ant-card {
    border: 1px solid ${({ theme }) => theme.colors.veryLightPink};
    border-radius: 4px;
    z-index: 1;
  }

  .mt40 {
    margin-top: 40px;
  }
`
